<template>
  <div class="proposta-wrapper">
    <!-- Mensagem para Rascunho -->
    <div v-if="statusCotacao === 'Rascunho'" class="wc-empty-state">
        <v-icon size="80" color="grey lighten-1" class="mb-4">mdi-file-document-outline</v-icon>
        <h3 class="wc-empty-title">Cotação em Rascunho</h3>
        <p class="wc-empty-subtitle">
          Esta cotação ainda não foi publicada. Publique a cotação para que os fornecedores possam enviar suas propostas.
        </p>
        <p class="wc-empty-subtitle mt-2">
          Após a publicação, você poderá visualizar e analisar as propostas recebidas nesta aba.
        </p>
    </div>

    <!-- Conteúdo normal para cotações publicadas -->
    <template v-else>
    <div class="proposta-layout">
      <!-- Sidebar -->
      <aside class="sidebar-filter">
        <!-- (removido) banner + visualização, agora ficam no topo -->
        <div class="sidebar-section">
          <div class="section-card">
            <div class="section-card__header" @click="toggleCard('quickSelection')">
              <div>
                <p class="sidebar-title mb-1" :class="{ 'text-error': !quickSelection, 'text-muted': !hasProposals || isButtonsDisabled }">
                  Seleção Rápida (recomendado)
                  <v-chip x-small v-if="!hasProposals" color="warning" class="ml-2">Sem dados</v-chip>
                </p>
                <p class="sidebar-helper">
                  Escolha o melhor fornecedor para toda a cotação com 1 clique.
                </p>
              </div>
              <v-icon small color="#B0BEC5" :class="{ 'rotate-180': !isQuickSelectionExpanded }">
                {{ isQuickSelectionExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </div>
            <transition name="slide-fade">
              <div v-show="isQuickSelectionExpanded" class="card-content">
                <v-radio-group v-model="quickSelection" hide-details class="mt-2" :class="{ 'radio-error': !quickSelection }" :disabled="!hasProposals || isButtonsDisabled">
                  <v-radio label="Menor custo total" value="menor_custo" color="primary" dense></v-radio>
                  <v-radio label="Melhor prazo de entrega" value="melhor_prazo" color="primary" dense></v-radio>
                </v-radio-group>
              </div>
            </transition>
          </div>
        </div>



        <div class="sidebar-section">
          <div class="section-card">
            <div class="section-card__header" @click="toggleCard('filters')">
              <div>
                <p class="sidebar-title mb-1">Filtros</p>
                <p class="sidebar-helper">
                  Filtre fornecedores por custo, prazo, confiabilidade e cobertura, e ajuste item a item.
                </p>
              </div>
              <v-icon small color="#B0BEC5" :class="{ 'rotate-180': !isFiltersExpanded }">
                {{ isFiltersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </div>

            <transition name="slide-fade">
              <div v-show="isFiltersExpanded" class="card-content">
                <label class="field-label mt-3">Fornecedor</label>
                <v-select
                    v-model="selectedSupplier"
                    :items="supplierOptions"
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                ></v-select>

                <v-tooltip right max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <label class="field-label d-inline-flex align-center" v-bind="attrs" v-on="on" style="cursor: help;">
                      Tipo de frete
                      <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </label>
                  </template>
                  <span>Filtra propostas pelo tipo de frete informado pelo fornecedor. CIF = frete incluso; FOB = frete por conta do comprador.</span>
                </v-tooltip>
                <v-select
                    v-model="selectedFreightType"
                    :items="freightTypeOptions"
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                ></v-select>

                <v-tooltip right max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <label class="field-label d-inline-flex align-center" v-bind="attrs" v-on="on" style="cursor: help;">
                      Preço Máx. (R$)
                      <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </label>
                  </template>
                  <span>Oculta propostas cujo preço unitário (campo "Preço unit." na tabela) ultrapasse este valor. Referência: preço unitário informado pelo fornecedor na proposta.</span>
                </v-tooltip>
                <v-text-field
                    v-model="maxPrice"
                    placeholder="Sem limites"
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                ></v-text-field>

                <v-tooltip right max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <label class="field-label d-inline-flex align-center" v-bind="attrs" v-on="on" style="cursor: help;">
                      Prazo Máx. (dias)
                      <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </label>
                  </template>
                  <span>Oculta propostas cujo prazo de entrega (em dias corridos) seja maior que este valor. Desabilitado quando o filtro de frete está em FOB, pois o prazo de entrega FOB é indeterminado.</span>
                </v-tooltip>
                <v-text-field
                    v-model="maxDelivery"
                    :placeholder="selectedFreightType === 'FOB' ? 'Desabilitado para FOB' : 'Sem limite'"
                    :disabled="selectedFreightType === 'FOB'"
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                ></v-text-field>

                <div class="advanced-options-toggle" @click="isAdvancedOptionsExpanded = !isAdvancedOptionsExpanded">
                  <v-icon small class="mr-1">{{ isAdvancedOptionsExpanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                  <span class="field-label mb-0" style="cursor: pointer;">Opções avançadas</span>
                </div>
                <transition name="slide">
                  <div v-if="isAdvancedOptionsExpanded" class="mt-2">
                    <v-tooltip right max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <label class="field-label d-inline-flex align-center" v-bind="attrs" v-on="on" style="cursor: help;">
                          Cobertura mínima do mix (%)
                          <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </label>
                      </template>
                      <span>Aplicado na visão "Por fornecedor". Oculta fornecedores que atendem menos do que este percentual dos itens da cotação. Ex: se a cotação tem 10 itens e você definir 80%, só aparecem fornecedores que atendem pelo menos 8 itens.</span>
                    </v-tooltip>
                    <v-text-field
                      v-model="minCoverage"
                      placeholder="Ex: 80"
                      type="number"
                      min="0"
                      max="100"
                      dense
                      outlined
                      hide-details
                      class="mb-3"
                    ></v-text-field>

                    <v-tooltip right max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="d-inline-block" style="cursor: help;">
                          <v-checkbox
                            v-model="hideOutOfTolerance"
                            dense
                            hide-details
                            class="mt-0 mb-2"
                          >
                            <template v-slot:label>
                              <span class="d-flex align-center">
                                Ocultar propostas fora da tolerância de qtd.
                                <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                              </span>
                            </template>
                          </v-checkbox>
                        </div>
                      </template>
                      <span>Esconde propostas onde a quantidade ofertada pelo fornecedor é diferente da quantidade desejada do item. Referência: "Qtd. desejada" configurada para cada produto da cotação vs "Qtd. ofertada" na proposta.</span>
                    </v-tooltip>

                    <v-tooltip right max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="d-inline-block" style="cursor: help;">
                          <v-checkbox
                            v-model="hideAboveReference"
                            dense
                            hide-details
                            class="mt-0 mb-2"
                          >
                            <template v-slot:label>
                              <span class="d-flex align-center">
                                Ocultar propostas acima de 20% do preço ref.
                                <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                              </span>
                            </template>
                          </v-checkbox>
                        </div>
                      </template>
                      <span>Esconde propostas cujo preço unitário é mais de 20% acima do preço de referência do item (última compra).</span>
                    </v-tooltip>
                  </div>
                </transition>
              </div>
            </transition>
          </div>

        </div>
      </aside>

      <!-- Content -->
      <section class="content">
        <div class="proposta-head proposta-head--bar">
          <div class="head-controls">
            <div class="head-view">
              <p class="sidebar-title mb-1">Visualização das propostas</p>
              <v-btn-toggle class="segmented-control" v-model="viewType" mandatory dense>
                <v-btn value="item" class="text-capitalize">Por item</v-btn>
                <v-btn value="fornecedor" class="text-capitalize">Por fornecedor</v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <div class="head-actions">
            <v-btn outlined color="primary" class="text-capitalize mr-2" @click="saveInAnalysis" :disabled="isButtonsDisabled">
              Salvar Atualizações
            </v-btn>
            <v-btn color="primary" class="text-capitalize" elevation="0" @click="confirmSuppliers" :disabled="isButtonsDisabled">
              Confirmar fornecedores e concluir análise
            </v-btn>
          </div>
        </div>

        <div class="summary-row">
          <div class="section-card summary-card-left">
            <div class="summary-card-header">
              <p class="summary-label mb-0">Itens com ganhador</p>
              <v-btn
                text
                small
                color="primary"
                class="text-capitalize pa-0 ver-detalhes-btn"
                @click="openModalItensGanhadores"
              >
                Ver detalhes
                <v-icon small right class="ml-1">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <div class="summary-value-wrapper">
              <span class="summary-value-hero">
                <span class="summary-value-current">{{ itemsWithWinner }}</span>
                <span class="summary-value-muted"> / {{ totalItems }}</span>
              </span>
              <v-checkbox
                v-model="showItemsWithoutWinner"
                label="Mostrar apenas itens sem ganhador"
                hide-details
                dense
                class="view-type-checkbox summary-only-winner ml-3"
              ></v-checkbox>
              <v-btn
                text
                x-small
                color="primary"
                class="ml-2 text-capitalize clear-winners-btn"
                :disabled="isButtonsDisabled"
                @click="clearWinners"
              >
                Limpar ganhadores
              </v-btn>
            </div>
            <div class="progress-bar-wrapper mt-2 mb-2">
              <div class="progress-bar">
                <div
                  v-for="segment in winnerDistribution.segments"
                  :key="segment.supplierName"
                  class="progress-segment"
                  :style="{ width: segment.percent + '%', backgroundColor: segment.color }"
                ></div>
                <div
                  v-if="winnerDistribution.semGanhador > 0"
                  class="progress-segment progress-segment--no-winner"
                  :style="{ width: winnerDistribution.semGanhadorPercent + '%' }"
                ></div>
              </div>
            </div>
            <div class="supplier-chips-row mb-1">
              <span
                v-for="chip in winnerDistribution.chips"
                :key="chip.key"
                class="supplier-chip"
              >
                <span class="supplier-chip__dot" :style="{ backgroundColor: chip.color }"></span>
                {{ chip.label }}
              </span>
            </div>
          </div>

          <div class="section-card summary-card-right">
            <div class="summary-right-grid">
              <div>
                <p class="summary-label">Fornecedores ganhadores</p>
                <div class="summary-value-wrapper">
                  <span class="summary-value">{{ winningSuppliers }}</span>
                  <v-icon small color="primary" class="ml-1">mdi-truck</v-icon>
                </div>
                <p class="summary-helper">Principal fornecedor: {{ mainSupplier }}</p>
              </div>

              <div class="summary-right-cost">
                <p class="summary-label">Custo total estimado</p>
                <p class="summary-value">{{ formatCurrency(totalCost) }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="active-filters mt-3 mb-3" v-if="activeFilters.length">
          <v-btn outlined x-small color="primary" class="text-capitalize mr-3 clear-filters-btn" @click="clearFilters">
            <v-icon small left>mdi-broom</v-icon>
            Limpar filtros
          </v-btn>
          <v-chip
              v-for="filter in activeFilters"
              :key="filter"
              close
              small
              class="mr-2 filter-chip"
              @click:close="removeFilter(filter)"
          >
            {{ filter }}
          </v-chip>
        </div>

        <v-card flat class="items-card">
          <div class="items-card__header">
            <div>
              <p class="items-card__title">{{ viewType === 'item' ? 'Itens com propostas' : 'Análise por fornecedores' }}</p>
              <p class="items-card__subtitle">
                {{ viewType === 'item'
                  ? 'Visualize por item da cotação as propostas dos fornecedores, você pode trocar ou definir um fornecedor ganhador.'
                  : 'Visualize a análise por fornecedor' }}
              </p>
              <v-tooltip v-if="prazoEntregaReferenciaDias != null" bottom max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="prazo-referencia-badge mt-2" style="cursor: help;">
                    <v-icon small color="#1565c0" class="mr-1">mdi-clock-outline</v-icon>
                    <span>Prazo de entrega desejado: <strong>{{ prazoEntregaReferenciaDias }} dia(s)</strong></span>
                  </div>
                </template>
                <span>Prazo mínimo desejado configurado nos locais de recebimento desta cotação. Usado como referência para os selos "Melhor/Pior vs prazo desejado".</span>
              </v-tooltip>
            </div>
            <div v-if="viewType === 'item'" class="items-navigation">
              <span class="items-navigation__text">{{ filteredItems.length > 0 ? currentIndex + 1 : 0 }} de {{ filteredItems.length }}</span>
              <div class="nav-buttons">
                <v-btn icon small :disabled="currentIndex === 0" @click="previousItem" class="nav-btn">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn icon small :disabled="currentIndex >= filteredItems.length - 1" @click="nextItem" class="nav-btn">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <div v-if="viewType === 'item' && !currentItem" class="wc-empty-state">
            <v-icon size="64" color="#e0e0e0" class="mb-4">mdi-filter-remove-outline</v-icon>
            <p class="wc-empty-title">Sem resultado para filtragem.</p>
            <p class="wc-empty-subtitle">Limpe o filtro e realize outra busca.</p>
          </div>

          <div class="product-info" v-else-if="viewType === 'item' && currentItem">
            <v-simple-table class="product-details-table">
              <thead>
              <tr>
                <th class="text-left">Produto</th>
                <th class="text-left">Preço última compra</th>
                <th class="text-left">Código</th>
                <th class="text-left">Unidade</th>
                <th class="text-left">Quantidade desejada</th>
                <th class="text-left">nº de propostas recebidas</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ currentItem.productName }}</td>
                <td>{{ formatLastPurchasePrice(currentItem.lastPurchasePrice) }}</td>
                <td>{{ currentItem.code }}</td>
                <td>{{ currentItem.unit }}</td>
                <td>{{ formatQuantity(currentItem.desiredQuantity) }}</td>
                <td>{{ currentItem.proposalsCount }}</td>
              </tr>
              </tbody>
            </v-simple-table>

            <!-- Produto -->
            <div class="proposals-table-wrapper mt-4" v-if="currentItem.proposals && currentItem.proposals.length">
              <v-simple-table class="proposals-table">
                <thead>
                <tr>
                  <th class="text-left pl-4">Fornecedor / proposta</th>
                  <th class="text-left">
                    <v-tooltip top max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Quantidade ofertada
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>
                        Quantidade informada pelo fornecedor neste item. Os limites de aceite vêm do cadastro do item na cotação (qtd. mínima/máxima aceita na embalagem).
                      </span>
                    </v-tooltip>
                  </th>
                  <th class="text-left">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Preço unit.
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>
                        Preço unitário do item, em reais.
                      </span>
                    </v-tooltip>
                  </th>
                  <th class="text-left">
                    Custo total
                  </th>
                  <th class="text-left">
                    <v-tooltip top max-width="280">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Preço ref.
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>Preço de referência do cliente para este item (última compra).</span>
                    </v-tooltip>
                  </th>
                  <th class="text-left">
                    <v-tooltip top max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Var. vs ref.
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>Diferença percentual entre o preço proposto e o preço de referência (ex.: -5%, +12%).</span>
                    </v-tooltip>
                  </th>
                  <th class="text-left">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Tipo Frete
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>
                        CIF: fornecedor entrega no endereço indicado; frete incluso no preço.&#10;&#10;FOB: comprador retira ou contrata o frete; frete não incluso no preço.
                      </span>
                    </v-tooltip>
                  </th>
                  <th class="text-left">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Prazo faturamento (Dias)
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>
                        Dias entre a confirmação do pedido e a emissão da nota fiscal. A partir do faturamento começa a contar o prazo de entrega.
                      </span>
                    </v-tooltip>
                  </th>
                  <th class="text-left">
                    Prazo entrega (Dias)
                  </th>
                  <th class="text-left">
                    <v-tooltip top max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs" style="cursor: help" class="d-flex align-center">
                          Cond. pagamento
                          <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                        </div>
                      </template>
                      <span>Condição de pagamento oferecida pelo fornecedor para este item (com parcelamento e meios).</span>
                    </v-tooltip>
                  </th>
                  <th class="text-center">Negociação</th>
                  <th class="text-center">Ganhador</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="proposal in currentItem.proposals"
                    :key="proposal.id"
                    :class="{ 'winner-row': proposal.isWinner }"
                >
                  <td class="pl-4">
                    <div class="supplier-info">
                      <span class="supplier-name">{{ proposal.supplierName }}</span>
                      <span class="supplier-cnpj">{{ proposal.cnpj }}</span>
                      <app-badge
                        v-if="deveExibirStatusPropostaFornecedor(proposal)"
                        :color="proposal.status === 'Não atende' ? 'error' : 'success'"
                        rounded
                      >{{ proposal.status }}</app-badge>
                      <div
                        v-for="ctx in ([getSeloQuantidadeOfertadaContextoFornecedor(proposal)].filter((x) => x))"
                        :key="'selo-qtd-forn-' + proposal.id"
                        class="proposal-inline-selos d-flex flex-column mt-1"
                        style="gap: 4px;"
                      >
                        <v-tooltip bottom max-width="360">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="d-inline-block">
                              <app-badge
                                :color="ctx.badge.color"
                                rounded
                              >
                                <span :class="['mdi mr-1 text-sm-body-1', ctx.badge.icon]"></span>
                                {{ ctx.nome }}
                              </app-badge>
                            </span>
                          </template>
                          <span>{{ ctx.tooltip }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </td>
                  <td class="proposal-value">
                    <div>{{ !isProposalNaoAtende(proposal) && proposal.offeredQuantity != null && proposal.offeredQuantity !== '' ? formatQuantity(proposal.offeredQuantity) : '–' }}</div>
                    <div
                      v-for="ctx in ([getSeloQuantidadeOfertadaContexto(proposal)].filter((x) => x))"
                      :key="'selo-qtd-' + proposal.id"
                      class="proposal-inline-selos d-flex flex-column mt-1"
                      style="gap: 4px;"
                    >
                      <v-tooltip
                        bottom
                        max-width="360"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-block">
                            <app-badge
                              :color="ctx.badge.color"
                              rounded
                            >
                              <span :class="['mdi mr-1 text-sm-body-1', ctx.badge.icon]"></span>
                              {{ ctx.nome }}
                            </app-badge>
                          </span>
                        </template>
                        <span>{{ ctx.tooltip }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td class="proposal-value">
                    <div>{{ !isProposalNaoAtende(proposal) && proposal.unitPrice ? proposal.unitPrice : '–' }}</div>
                    <div v-if="selosDistribuidosItemView(proposal).precoUnitario.length" class="proposal-inline-selos d-flex flex-column mt-1" style="gap: 4px;">
                      <v-tooltip
                        v-for="(b, bi) in selosDistribuidosItemView(proposal).precoUnitario"
                        :key="'pu-' + proposal.id + '-' + bi"
                        bottom
                        max-width="360"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-block">
                            <app-badge
                              :color="getBadgeConfig(b.nome).color"
                              rounded
                            >
                              <span :class="['mdi mr-1 text-sm-body-1', getBadgeConfig(b.nome).icon]"></span>
                              {{ b.nome }}
                            </app-badge>
                          </span>
                        </template>
                        <span>{{ b.descricao }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td class="proposal-value">{{ !isProposalNaoAtende(proposal) && proposal.totalCost ? proposal.totalCost : '–' }}</td>
                  <td class="proposal-value">{{ !isProposalNaoAtende(proposal) && currentItem.lastPurchasePrice != null ? formatLastPurchasePrice(currentItem.lastPurchasePrice) : '–' }}</td>
                  <td class="proposal-value">
                    <div>
                      <span
                        v-if="!isProposalNaoAtende(proposal) && proposal.variacaoPct != null"
                        :class="{ 'success--text': proposal.variacaoPct < 0, 'error--text': proposal.variacaoPct > 0 }"
                      >{{ proposal.variacaoPct >= 0 ? '+' : '' }}{{ proposal.variacaoPct }}%</span>
                      <span v-else>–</span>
                    </div>
                    <div v-if="selosDistribuidosItemView(proposal).variacaoVsRef.length" class="proposal-inline-selos d-flex flex-column mt-1" style="gap: 4px;">
                      <v-tooltip
                        v-for="(b, bi) in selosDistribuidosItemView(proposal).variacaoVsRef"
                        :key="'vr-' + proposal.id + '-' + bi"
                        bottom
                        max-width="360"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-block">
                            <app-badge
                              :color="getBadgeConfig(b.nome).color"
                              rounded
                            >
                              <span :class="['mdi mr-1 text-sm-body-1', getBadgeConfig(b.nome).icon]"></span>
                              {{ b.nome }}
                            </app-badge>
                          </span>
                        </template>
                        <span>{{ b.descricao }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td class="proposal-value">{{ !isProposalNaoAtende(proposal) && proposal.tipoFrete ? proposal.tipoFrete : '–' }}</td>
                  <td class="proposal-value">{{ !isProposalNaoAtende(proposal) && proposal.prazoFaturamento != null ? proposal.prazoFaturamento : '–' }}</td>
                  <td class="proposal-value">
                    <div>{{ !isProposalNaoAtende(proposal) && proposal.deliveryTime != null && proposal.deliveryTime !== 0 ? proposal.deliveryTime + ' dias' : '–' }}</div>
                    <div v-if="selosDistribuidosItemView(proposal).prazoEntrega.length" class="proposal-inline-selos d-flex flex-column mt-1" style="gap: 4px;">
                      <v-tooltip
                        v-for="(b, bi) in selosDistribuidosItemView(proposal).prazoEntrega"
                        :key="'pe-' + proposal.id + '-' + bi"
                        bottom
                        max-width="360"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-block">
                            <app-badge
                              :color="getBadgeConfig(b.nome).color"
                              rounded
                            >
                              <span :class="['mdi mr-1 text-sm-body-1', getBadgeConfig(b.nome).icon]"></span>
                              {{ b.nome }}
                            </app-badge>
                          </span>
                        </template>
                        <span>{{ b.descricao }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td class="proposal-value">{{ !isProposalNaoAtende(proposal) && proposal.condicaoPagamentoLabel ? proposal.condicaoPagamentoLabel : '–' }}</td>
                  <td class="text-center">
                    <template v-if="getAjusteAtivoFornecedor(proposal.supplierId)">
                      <v-tooltip bottom max-width="280">
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="ajuste-badge-solicitado"
                          >
                            Ajuste solicitado até {{ formatarDataBR(getAjusteAtivoFornecedor(proposal.supplierId).data_limite) }}
                          </span>
                        </template>
                        <span>O fornecedor pode editar e reenviar a proposta até esse prazo.</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip bottom max-width="280">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-block">
                            <v-btn
                              x-small
                              text
                              color="primary"
                              class="text-capitalize"
                              :disabled="isButtonsDisabled || proposal.status === 'Não atende'"
                              @click="abrirModalAjuste(proposal.supplierId)"
                            >
                              <v-icon x-small left>mdi-pencil-outline</v-icon>
                              Solicitar ajuste
                            </v-btn>
                          </span>
                        </template>
                        <span v-if="proposal.status === 'Não atende'">Não é possível solicitar ajuste: o fornecedor indicou que não atende este item.</span>
                        <span v-else>Solicitar alteração de valores ou condições desta proposta ao fornecedor.</span>
                      </v-tooltip>
                    </template>
                  </td>
                  <td class="text-right pr-4">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          elevation="0"
                          small
                          outlined
                          :color="proposal.isWinner ? 'success' : 'primary'"
                          :disabled="isButtonsDisabled || proposal.status === 'Não atende'"
                          @click="setWinner(currentItem.id, proposal.id)"
                        >
                          <v-icon left small v-if="proposal.isWinner">mdi-check-circle</v-icon>
                          {{ proposal.isWinner ? 'Ganhador' : 'Definir ganhador' }}
                        </v-btn>
                      </template>
                      <span>
                        {{ proposal.isWinner ? 'Clique para remover o ganhador do produto' : 'Clique para definir o ganhador do produto' }}
                      </span>
                    </v-tooltip>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </div>

            <div v-else class="wc-empty-state">
              <v-icon size="64" color="#e0e0e0" class="mb-4">mdi-cart-minus</v-icon>
              <p class="wc-empty-title">Ainda não há propostas para este item</p>
            </div>
          </div>

          <!-- Fornecedor -->
          <div class="product-info" v-else-if="viewType === 'fornecedor'">
            <div class="supplier-matrix" v-if="filteredSuppliersView && filteredSuppliersView.length">
              <div class="supplier-matrix__scroll">
                <div class="supplier-matrix__grid">
                  <div class="supplier-matrix__metric-col">
                    <div class="supplier-matrix__metric-head">Métricas</div>
                    <div class="supplier-matrix__metric-row">Itens atendidos</div>
                    <div class="supplier-matrix__metric-row">Itens não atendidos</div>
                    <div class="supplier-matrix__metric-row">Itens ganhos</div>
                    <div class="supplier-matrix__metric-row">
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">Valor total <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon></span>
                        </template>
                        <span>Soma dos <strong>custos totais</strong> das propostas deste fornecedor em cada <strong>item atendido</strong> (quantidade e valores que ele informou na cotação). O número ao lado é esse total agregado.</span>
                      </v-tooltip>
                    </div>
                    <div class="supplier-matrix__metric-row">
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">Tipo de frete <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon></span>
                        </template>
                        <span>Distribuição do tipo de frete nos itens atendidos (CIF, FOB ou Misto).</span>
                      </v-tooltip>
                    </div>
                    <div class="supplier-matrix__metric-row">
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">Prazo de faturamento (dias) <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon></span>
                        </template>
                        <span>Prazo em dias após o pedido para emissão da NF (contido no prazo de entrega).</span>
                      </v-tooltip>
                    </div>
                    <div class="supplier-matrix__metric-row">
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">Prazo de entrega (dias) <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon></span>
                        </template>
                        <span>Prazo em dias após o pedido para entrega (já inclui faturamento; não somar).</span>
                      </v-tooltip>
                    </div>
                    <div class="supplier-matrix__metric-row">
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">Condição de pagamento <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon></span>
                        </template>
                        <span>Condição de pagamento oferecida pelo fornecedor nos itens atendidos.</span>
                      </v-tooltip>
                    </div>
                    <div class="supplier-matrix__metric-row">
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">Preço vs referência <v-icon x-small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon></span>
                        </template>
                        <span>Diferença percentual média entre o preço proposto e o preço de referência (último preço) nos itens atendidos.</span>
                      </v-tooltip>
                    </div>
                  </div>

                  <div
                    v-for="supplier in filteredSuppliersView"
                    :key="supplier.id"
                    class="supplier-matrix__supplier-col"
                  >
                    <div class="supplier-matrix__supplier-head">
                      <div class="supplier-matrix__supplier-title">
                        <v-tooltip bottom max-width="320" :disabled="!supplier.supplierName || String(supplier.supplierName).length < 48">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="supplier-matrix__supplier-name"
                              v-bind="attrs"
                              v-on="on"
                            >{{ supplier.supplierName }}</div>
                          </template>
                          <span>{{ supplier.supplierName }}</span>
                        </v-tooltip>
                        <div class="supplier-matrix__supplier-cnpj">{{ supplier.cnpj || '—' }}</div>
                        <div
                          v-if="supplier.naoAtendeNenhumItem"
                          class="text-caption error--text mt-1"
                          style="line-height: 1.35;"
                        >
                          Não atende nenhum item desta cotação.
                        </div>
                      </div>
                      <div class="supplier-matrix__supplier-actions">
                        <app-badge
                          v-if="supplier.naoAtendeNenhumItem"
                          color="error"
                          rounded
                        >
                          Não atende
                        </app-badge>
                        <app-badge
                          v-else-if="supplier.status"
                          :color="supplier.status === 'Não atende' ? 'error' : 'success'"
                          rounded
                        >
                          {{ supplier.status }}
                        </app-badge>

                        <v-tooltip bottom max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="d-inline-block">
                              <v-btn
                                elevation="0"
                                small
                                outlined
                                :color="(supplier.isTotalWinner || supplier.isPartialWinner || supplier.isWinnerPendingItems) ? 'success' : 'primary'"
                                :disabled="isButtonsDisabled || supplier.naoAtendeNenhumItem || (hasPartialWinner && !hasItensRestantesSemGanhador && !supplier.isTotalWinner && !supplier.isPartialWinner && !supplier.isWinnerPendingItems)"
                                class="text-capitalize"
                                @click="setWinnerBySupplier(supplier.supplierName, { onlyPendingItems: hasPartialWinner && hasItensRestantesSemGanhador && !supplier.isPartialWinner && !supplier.isTotalWinner && !supplier.isWinnerPendingItems })"
                              >
                                <v-icon left small v-if="supplier.isTotalWinner || supplier.isPartialWinner || supplier.isWinnerPendingItems">mdi-check-circle</v-icon>
                                {{ supplier.isTotalWinner ? 'Ganhador' : (supplier.isPartialWinner ? 'Ganhador parcial' : (supplier.isWinnerPendingItems ? 'Ganhador itens restantes' : (hasPartialWinner ? 'Definir ganhador itens restantes' : 'Definir ganhador'))) }}
                              </v-btn>
                            </span>
                          </template>
                          <span v-if="supplier.naoAtendeNenhumItem">Não é possível definir ganhador: o fornecedor não atende nenhum item.</span>
                        <span v-else-if="hasPartialWinner && !hasItensRestantesSemGanhador && !supplier.isTotalWinner && !supplier.isPartialWinner && !supplier.isWinnerPendingItems">Não há itens restantes sem ganhador para definir.</span>
                          <span v-else>{{ supplier.isTotalWinner ? 'Clique para remover o ganhador dos itens' : 'Definir este fornecedor como ganhador' }}</span>
                        </v-tooltip>

                        <template v-if="getAjusteAtivoFornecedor(supplier.supplierId)">
                          <v-tooltip bottom max-width="280">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="ajuste-badge-solicitado"
                              >
                                Ajuste solicitado até {{ formatarDataBR(getAjusteAtivoFornecedor(supplier.supplierId).data_limite) }}
                              </span>
                            </template>
                            <span>O fornecedor pode editar e reenviar a proposta até esse prazo.</span>
                          </v-tooltip>
                        </template>
                        <v-tooltip v-else bottom max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="d-inline-block">
                              <v-btn
                                x-small
                                text
                                color="primary"
                                class="text-capitalize"
                                :disabled="isButtonsDisabled || supplier.naoAtendeNenhumItem"
                                @click="abrirModalAjuste(supplier.supplierId)"
                              >
                                <v-icon x-small left>mdi-pencil-outline</v-icon>
                                Solicitar ajuste
                              </v-btn>
                            </span>
                          </template>
                          <span v-if="supplier.naoAtendeNenhumItem">Não é possível solicitar ajuste: o fornecedor não atende nenhum item desta cotação.</span>
                          <span v-else>Solicitar alteração de valores ou condições ao fornecedor.</span>
                        </v-tooltip>
                      </div>
                    </div>

                    <div class="supplier-matrix__cell">
                      <div class="d-flex align-center justify-space-between">
                        <span>{{ supplier.itemsTotal != null ? supplier.itemsTotal : 0 }} itens</span>
                        <v-btn text x-small color="primary" class="text-capitalize pa-0 ml-2" @click="openModalItensFornecedor(supplier.supplierName, 'atendidos')">
                          Ver itens
                        </v-btn>
                      </div>
                    </div>

                    <div class="supplier-matrix__cell">
                      <div class="d-flex align-center justify-space-between">
                        <span>{{ supplier.itemsNotAttended || 0 }} {{ (supplier.itemsNotAttended || 0) === 1 ? 'item' : 'itens' }}</span>
                        <v-btn text x-small color="primary" class="text-capitalize pa-0 ml-2" @click="openModalItensFornecedor(supplier.supplierName, 'nao_atendidos')">
                          Ver itens
                        </v-btn>
                      </div>
                    </div>

                    <div class="supplier-matrix__cell">
                      <div class="d-flex align-center justify-space-between">
                        <span class="supplier-matrix__cell-strong">{{ supplier.itemsWinnerCount || 0 }} itens</span>
                        <v-btn text x-small color="primary" class="text-capitalize pa-0 ml-2" @click="openModalItensFornecedor(supplier.supplierName, 'ganhos')">
                          Ver itens
                        </v-btn>
                      </div>
                    </div>

                    <!-- Valor total + selo "Mais barato" inline -->
                    <div class="supplier-matrix__cell">
                      <div class="d-flex align-center flex-wrap" style="gap: 6px;">
                        <span>{{ typeof supplier.totalValueOfItems === 'string' ? supplier.totalValueOfItems : formatCurrency(supplier.totalValueOfItems) }}</span>
                        <v-tooltip v-if="supplier.seloValorTotal" bottom max-width="360">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="d-inline-block">
                              <app-badge :color="getBadgeConfig(supplier.seloValorTotal.nome).color" rounded>
                                <span :class="['mdi mr-1 text-sm-body-1', getBadgeConfig(supplier.seloValorTotal.nome).icon]"></span>
                                {{ supplier.seloValorTotal.nome }}
                              </app-badge>
                            </span>
                          </template>
                          <span>{{ supplier.seloValorTotal.descricao }}</span>
                        </v-tooltip>
                      </div>
                    </div>

                    <!-- Tipo de frete agregado com tooltip detalhado -->
                    <div class="supplier-matrix__cell">
                      <v-tooltip v-if="supplier.freteAgregado" bottom max-width="360">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">{{ supplier.freteAgregado.texto }}</span>
                        </template>
                        <span style="white-space: pre-line">{{ supplier.freteAgregado.tooltip }}</span>
                      </v-tooltip>
                      <span v-else>{{ supplier.tipoFrete || '–' }}</span>
                    </div>

                    <!-- Prazo de faturamento agregado com tooltip min/média/mediana/máx -->
                    <div class="supplier-matrix__cell">
                      <v-tooltip v-if="supplier.prazoFaturamentoAgregado" bottom max-width="360">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">média {{ supplier.prazoFaturamentoAgregado.media }} dias</span>
                        </template>
                        <span style="white-space: pre-line">Prazo em dias após o pedido para emissão da NF (contido no prazo de entrega).
Mín: {{ supplier.prazoFaturamentoAgregado.min }} dia(s)
Média: {{ supplier.prazoFaturamentoAgregado.media }} dia(s)
Mediana: {{ supplier.prazoFaturamentoAgregado.mediana }} dia(s)
Máx: {{ supplier.prazoFaturamentoAgregado.max }} dia(s)</span>
                      </v-tooltip>
                      <span v-else>{{ supplier.prazoFaturamento != null ? supplier.prazoFaturamento : '–' }}</span>
                    </div>

                    <!-- Prazo de entrega agregado + selos "Mais rápido", "Melhor/Pior vs último prazo" inline -->
                    <div class="supplier-matrix__cell">
                      <div class="d-flex align-center flex-wrap" style="gap: 6px;">
                        <v-tooltip v-if="supplier.prazoEntregaAgregado" bottom max-width="360">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" style="cursor: help">média {{ supplier.prazoEntregaAgregado.media }} dias</span>
                          </template>
                          <span style="white-space: pre-line">Prazo em dias após o pedido para entrega (já inclui faturamento; não somar).
                            Mín: {{ supplier.prazoEntregaAgregado.min }} dia(s)
                            Média: {{ supplier.prazoEntregaAgregado.media }} dia(s)
                            Mediana: {{ supplier.prazoEntregaAgregado.mediana }} dia(s)
                            Máx: {{ supplier.prazoEntregaAgregado.max }} dia(s)
                          </span>
                        </v-tooltip>
                        <span v-else>{{ supplier.prazoEntrega != null && supplier.prazoEntrega !== 0 ? supplier.prazoEntrega + ' dias' : '–' }}</span>
                        <v-tooltip
                          v-for="(s, si) in supplier.selosPrazoEntrega"
                          :key="'spe-' + supplier.supplierName + '-' + si"
                          bottom
                          max-width="360"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="d-inline-block">
                              <app-badge :color="getBadgeConfig(s.nome).color" rounded>
                                <span :class="['mdi mr-1 text-sm-body-1', getBadgeConfig(s.nome).icon]"></span>
                                {{ s.nome }}
                              </app-badge>
                            </span>
                          </template>
                          <span>{{ s.descricao }}</span>
                        </v-tooltip>
                      </div>
                    </div>

                    <!-- Condição de pagamento agregada com tooltip de distribuição -->
                    <div class="supplier-matrix__cell">
                      <v-tooltip v-if="supplier.condicaoPagamentoAgregado" bottom max-width="400">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" style="cursor: help">{{ supplier.condicaoPagamentoAgregado.texto }}</span>
                        </template>
                        <span style="white-space: pre-line">{{ supplier.condicaoPagamentoAgregado.tooltip }}</span>
                      </v-tooltip>
                      <span v-else>–</span>
                    </div>

                    <!-- Preço vs referência + selo "Melhor/Pior vs último preço" inline -->
                    <div class="supplier-matrix__cell">
                      <div class="d-flex align-center flex-wrap" style="gap: 6px;">
                        <span :class="{'success--text': supplier.precoVsReferencia && supplier.precoVsReferencia.media_delta_pct < 0, 'error--text': supplier.precoVsReferencia && supplier.precoVsReferencia.media_delta_pct > 0}">
                          {{ supplier.precoVsReferencia ? supplier.precoVsReferencia.texto : '–' }}
                        </span>
                        <v-tooltip v-if="supplier.seloPrecoVsRef" bottom max-width="360">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="d-inline-block">
                              <app-badge :color="getBadgeConfig(supplier.seloPrecoVsRef.nome).color" rounded>
                                <span :class="['mdi mr-1 text-sm-body-1', getBadgeConfig(supplier.seloPrecoVsRef.nome).icon]"></span>
                                {{ supplier.seloPrecoVsRef.nome }}
                              </app-badge>
                            </span>
                          </template>
                          <span>{{ supplier.seloPrecoVsRef.descricao }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="wc-empty-state">
              <v-icon size="64" color="#e0e0e0" class="mb-4">mdi-cart-minus</v-icon>
              <p class="wc-empty-title">Ainda não há propostas de fornecedores</p>
            </div>
          </div>
        </v-card>
      </section>
    </div>

    <v-dialog
      v-model="modalItensGanhadores"
      max-width="920"
      scrollable
      content-class="itens-ganhadores-dialog"
    >
      <v-card>
        <v-card-title class="d-flex align-start justify-space-between pb-2">
          <div>
            <div class="text-h6 font-weight-bold">Itens e ganhadores</div>
            <div class="text-body-2 grey--text text--darken-1 font-weight-regular mt-1">
              Lista completa dos itens desta cotação e o fornecedor ganhador selecionado (quando existir).
            </div>
          </div>
          <v-btn icon small @click="closeModalItensGanhadores">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row dense class="mb-4">
            <v-col cols="12" md="6">
              <label class="field-label">Fornecedor</label>
              <v-select
                v-model="modalFornecedor"
                :items="supplierOptions"
                item-text="text"
                item-value="value"
                dense
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" class="d-flex align-end">
              <v-checkbox
                v-model="modalSoloSemGanhador"
                label="Mostrar apenas itens sem ganhador"
                hide-details
                dense
                class="mt-0"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-simple-table class="modal-itens-table">
            <thead>
              <tr>
                <th class="text-left">Item</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Qtd.</th>
                <th class="text-left">Un.</th>
                <th class="text-left">Preço</th>
                <th class="text-left">Total do item</th>
                <th class="text-left">Fornecedor ganhador</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in modalItensRows" :key="row.id">
                <td>{{ row.codigo != null && row.codigo !== '' ? row.codigo : row.id }}</td>
                <td>{{ row.descricao }}</td>
                <td>{{ formatQuantity(row.qtd) }}</td>
                <td>{{ row.un || '–' }}</td>
                <td>{{ row.preco || '–' }}</td>
                <td>{{ row.totalDoItem || '–' }}</td>
                <td>
                  <v-chip
                    v-if="row.ganhador"
                    small
                    outlined
                    color="primary"
                    class="font-weight-regular"
                  >
                    {{ row.ganhador }}
                  </v-chip>
                  <span v-else class="grey--text text--darken-1 font-italic">Sem ganhador</span>
                </td>
              </tr>
              <tr v-if="!modalItensRows.length">
                <td colspan="7" class="text-center grey--text py-6">Nenhum item para exibir com os filtros atuais.</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-if="modalItensRows.length" class="d-flex justify-end mt-3">
            <span class="font-weight-bold">Total geral: {{ modalItensTotalGeral }}</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn color="primary" text class="text-capitalize" @click="closeModalItensGanhadores">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="modalItensFornecedor"
      max-width="720"
      scrollable
      content-class="itens-fornecedor-dialog"
    >
      <v-card>
        <v-card-title class="d-flex align-start justify-space-between pb-2">
          <div>
            <div class="text-h6 font-weight-bold">
              {{ modalItensFornecedorTipo === 'atendidos'
                ? `Itens atendidos - ${modalItensFornecedorNome}`
                : (modalItensFornecedorTipo === 'nao_atendidos'
                  ? `Itens não atendidos - ${modalItensFornecedorNome}`
                  : `Itens ganhos - ${modalItensFornecedorNome}`) }}
            </div>
            <div class="text-body-2 grey--text text--darken-1 font-weight-regular mt-1">
              Esta lista reflete os itens desta cotação para o fornecedor selecionado.
            </div>
          </div>
          <v-btn icon small @click="closeModalItensFornecedor">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-simple-table class="modal-itens-table">
            <thead>
              <tr>
                <th class="text-left">Item</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Qtd.</th>
                <th class="text-left">Un.</th>
                <th v-if="modalItensFornecedorTipo !== 'nao_atendidos'" class="text-left">Preço</th>
                <th v-if="modalItensFornecedorTipo !== 'nao_atendidos'" class="text-left">Total do item</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in modalItensFornecedorRows" :key="row.id">
                <td>{{ row.codigo != null && row.codigo !== '' ? row.codigo : row.id }}</td>
                <td>{{ row.descricao }}</td>
                <td>{{ formatQuantity(row.qtd) }}</td>
                <td>{{ row.un || '–' }}</td>
                <td v-if="modalItensFornecedorTipo !== 'nao_atendidos'">{{ row.preco || '–' }}</td>
                <td v-if="modalItensFornecedorTipo !== 'nao_atendidos'">{{ row.totalDoItem || '–' }}</td>
              </tr>
              <tr v-if="!modalItensFornecedorRows.length">
                <td :colspan="modalItensFornecedorTipo === 'nao_atendidos' ? 4 : 6" class="text-center grey--text py-6">Nenhum item para exibir.</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-if="modalItensFornecedorRows.length && modalItensFornecedorTipo !== 'nao_atendidos'" class="d-flex justify-end mt-3">
            <span class="font-weight-bold">Total geral: {{ modalItensFornecedorTotalGeral }}</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end pa-4" style="gap: 10px;">
          <v-btn text class="text-capitalize" @click="closeModalItensFornecedor">Fechar</v-btn>
          <v-btn
            color="primary"
            elevation="0"
            class="text-capitalize"
            :disabled="!modalItensFornecedorRows.length"
            @click="baixarXlsxModalItensFornecedor"
          >
            <v-icon left>mdi-download</v-icon>
            Baixar XLSX
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="modalConfirmacao"
      max-width="520"
      persistent
      content-class="confirmacao-dialog"
    >
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between pb-2">
          <span class="text-h6 font-weight-bold">Confirmar ganhadores e concluir análise</span>
          <v-btn icon small @click="modalConfirmacao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5 pb-4">
          <p class="text-body-2 grey--text text--darken-2 mb-4">
            Revise o resumo abaixo antes de confirmar. Após a confirmação, a análise será concluída e os ganhadores serão registrados.
          </p>
          <div class="confirmacao-resumo">
            <div class="confirmacao-resumo__item">
              <span class="confirmacao-resumo__label">Custo total estimado</span>
              <span class="confirmacao-resumo__value">{{ formatCurrency(totalCost) }}</span>
            </div>
            <v-divider class="my-2"></v-divider>
            <div class="confirmacao-resumo__item">
              <span class="confirmacao-resumo__label">Itens com ganhador</span>
              <span class="confirmacao-resumo__value">{{ itemsWithWinner }} de {{ totalItems }}</span>
            </div>
            <v-divider class="my-2"></v-divider>
            <div class="confirmacao-resumo__item">
              <span class="confirmacao-resumo__label">Fornecedores ganhadores</span>
              <span class="confirmacao-resumo__value">{{ winningSuppliers }}</span>
            </div>
          </div>
          <p v-if="itemsWithoutWinner > 0" class="text-caption warning--text mt-3 mb-0">
            <v-icon x-small color="warning" class="mr-1">mdi-alert</v-icon>
            {{ itemsWithoutWinner }} item(ns) ainda sem ganhador definido.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end pa-4" style="gap: 10px;">
          <v-btn text class="text-capitalize" @click="modalConfirmacao = false">Cancelar</v-btn>
          <v-btn color="primary" elevation="0" class="text-capitalize" @click="executeConfirmSuppliers">
            <v-icon left small>mdi-check-circle</v-icon>
            Confirmar e concluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Solicitar Ajuste de Proposta -->
    <v-dialog v-model="modalAjusteAberto" max-width="520" persistent>
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between pb-2">
          <span class="text-subtitle-1 font-weight-bold">Solicitar ajuste de proposta</span>
          <v-btn icon small @click="fecharModalAjuste" :disabled="modalAjusteLoading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-0 pb-2">
          <!-- Banner informativo -->
          <div style="background: #EFF6FF; border: 1px solid #BFDBFE; border-radius: 8px; padding: 12px 14px; margin-bottom: 20px;">
            <div class="d-flex" style="gap: 10px;">
              <v-icon small color="blue darken-1" class="mt-1" style="flex-shrink: 0;">mdi-information-outline</v-icon>
              <div class="text-caption" style="color: #1E40AF; line-height: 1.5;">
                Use este fluxo para negociar fora do sistema (WhatsApp / e-mail) e pedir que o fornecedor reenvie a proposta com ajustes.<br>
                Ao liberar alterações, o fornecedor poderá editar e reenviar a proposta no portal até o prazo definido.<br>
                A proposta ficará bloqueada novamente quando o fornecedor reenviar ou quando o prazo expirar.
              </div>
            </div>
          </div>

          <div class="mb-1">
            <div class="d-flex align-center mb-1" style="gap: 4px;">
              <span class="text-body-2 font-weight-bold" style="color: #1A202C;">Fornecedor</span>
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" x-small color="grey">mdi-information-outline</v-icon>
                </template>
                <span>A solicitação é enviada apenas para o fornecedor da proposta em que você clicou; não é possível trocar aqui.</span>
              </v-tooltip>
            </div>
            <div
              v-if="modalAjusteFornecedorSelecionado"
              class="d-flex align-start"
              style="gap: 10px; border: 1px solid #E2E8F0; border-radius: 4px; padding: 10px 12px; background: #F7FAFC;"
            >
              <v-icon small color="grey darken-1" class="mt-1" style="flex-shrink: 0;">mdi-lock-outline</v-icon>
              <div style="min-width: 0;">
                <div class="text-body-2 font-weight-medium" style="color: #1A202C; word-break: break-word;">
                  {{ modalAjusteFornecedorExibicao.nome || '—' }}
                </div>
                <div v-if="modalAjusteFornecedorExibicao.cnpj" class="text-caption grey--text text--darken-1 mt-1">
                  {{ modalAjusteFornecedorExibicao.cnpj }}
                </div>
              </div>
            </div>
            <div v-else class="text-caption grey--text">—</div>
            <div v-if="modalAjusteErros.fornecedor" class="text-caption mt-1" style="color: #E53E3E;">Fornecedor inválido para esta solicitação.</div>
          </div>

          <!-- Contatos do fornecedor -->
          <div v-if="modalAjusteFornecedorSelecionado" class="mt-4 mb-4">
            <div style="border: 1px solid #E2E8F0; border-radius: 8px; padding: 12px 14px;">
              <div class="d-flex align-center mb-2" style="gap: 4px;">
                <span class="text-caption font-weight-bold" style="color: #4A5568;">Contatos do fornecedor</span>
                <v-tooltip bottom max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" x-small color="grey">mdi-information-outline</v-icon>
                  </template>
                  <span>Representantes cadastrados para este fornecedor nesta cotação. Eles serão notificados por e-mail e/ou WhatsApp.</span>
                </v-tooltip>
              </div>
              <div v-if="modalAjusteContatosLoading" class="text-caption grey--text">Carregando...</div>
              <div v-else-if="modalAjusteContatos.length === 0" class="text-caption grey--text">Nenhum contato encontrado.</div>
              <div v-else>
                <div
                  v-for="contato in modalAjusteContatos"
                  :key="contato.id"
                  class="d-flex align-center justify-space-between py-1"
                  style="gap: 8px;"
                >
                  <span class="text-body-2" style="color: #1A202C;">{{ contato.nome || '—' }}</span>
                  <div class="d-flex align-center" style="gap: 16px;">
                    <span v-if="contato.email" class="text-caption grey--text text--darken-1">{{ contato.email }}</span>
                    <span v-if="contato.telefone" class="text-caption grey--text text--darken-1">{{ contato.telefone }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Prazo para ajuste (dias) -->
          <div class="mt-4">
            <div class="d-flex align-center mb-1" style="gap: 4px;">
              <span class="text-body-2 font-weight-bold" style="color: #1A202C;">Prazo para ajuste (dias)</span>
              <v-tooltip bottom max-width="280">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" x-small color="grey">mdi-information-outline</v-icon>
                </template>
                <span>Número de dias que o fornecedor terá para editar e reenviar a proposta. Após o prazo, a proposta será bloqueada automaticamente.</span>
              </v-tooltip>
            </div>
            <v-text-field
              v-model.number="modalAjustePrazoDias"
              placeholder="Ex: 2"
              type="number"
              outlined
              dense
              hide-details
              min="1"
              :max="modalAjusteMaxDias != null ? modalAjusteMaxDias : 30"
              :disabled="modalAjusteLoading"
              :error="modalAjusteErros.prazo || modalAjustePrazoExcedido"
            ></v-text-field>
            <div v-if="modalAjustePrazoExcedido" class="text-caption mt-1" style="color: #E53E3E;">
              O prazo ultrapassa o término da cotação ({{ terminoCotacaoFormatado }}). Máximo permitido: {{ modalAjusteMaxDias }} dia(s).
            </div>
            <div v-else-if="modalAjusteErros.prazo" class="text-caption mt-1" style="color: #E53E3E;">Informe um prazo em dias maior que zero.</div>
            <div v-else-if="modalAjustePrazoDias > 0" class="text-caption mt-1 grey--text text--darken-1">
              O fornecedor poderá editar e reenviar a proposta até o prazo expirar.
            </div>
            <div v-if="terminoCotacaoFormatado && !modalAjustePrazoExcedido" class="text-caption mt-1 grey--text">
              Término da cotação: {{ terminoCotacaoFormatado }}
            </div>
          </div>

          <!-- Prazo final calculado -->
          <div v-if="modalAjustePrazoFinal" class="mt-4">
            <div :style="'border: 1px solid ' + (modalAjustePrazoExcedido ? '#FEB2B2' : '#E2E8F0') + '; border-radius: 8px; padding: 12px 14px; background: ' + (modalAjustePrazoExcedido ? '#FFF5F5' : 'white')">
              <div class="d-flex align-center mb-1" style="gap: 4px;">
                <span class="text-caption font-weight-bold" :style="'color: ' + (modalAjustePrazoExcedido ? '#C53030' : '#4A5568')">Prazo final</span>
                <v-tooltip bottom max-width="280">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" x-small :color="modalAjustePrazoExcedido ? 'error' : 'grey'">mdi-information-outline</v-icon>
                  </template>
                  <span>Data e hora limite para o fornecedor reenviar a proposta ajustada. Não pode ultrapassar o término da cotação.</span>
                </v-tooltip>
              </div>
              <div class="text-body-1 font-weight-bold" :style="'color: ' + (modalAjustePrazoExcedido ? '#C53030' : '#1A202C')">{{ modalAjustePrazoFinal }}</div>
              <div class="text-caption" :class="modalAjustePrazoExcedido ? 'red--text' : 'grey--text'">
                {{ modalAjustePrazoExcedido ? 'Excede o término da cotação!' : 'horário de Brasília' }}
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mt-2"></v-divider>
        <v-card-actions class="justify-end pa-4" style="gap: 10px;">
          <v-btn text class="text-capitalize" @click="fecharModalAjuste" :disabled="modalAjusteLoading">Cancelar</v-btn>
          <v-btn
            color="primary"
            elevation="0"
            class="text-capitalize"
            @click="enviarSolicitacaoAjuste"
            :loading="modalAjusteLoading"
            :disabled="modalAjustePrazoExcedido"
          >
            Liberar alterações na proposta
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
  </div>
</template>

<script setup>
import AppBadge from "@/components/utils/ui_v4/feedback/AppBadge.vue";
import { useDetalhesCotacaoPropostaTab } from "@/components/webcotacao/composables/useDetalhesCotacaoPropostaTab";
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  cotacaoId: { type: Number, required: false },
  statusCotacao: { type: String, required: false },
  terminoRecebimento: { type: String, required: false },
});

const emit = defineEmits(['refresh']);
  const {
    viewType,
    showItemsWithoutWinner,
    quickSelection,
    selectedSupplier,
    maxPrice,
    maxDelivery,
    selectedFreightType,
    freightTypeOptions,
    isQuickSelectionExpanded,

    isFiltersExpanded,
    toggleCard,
    supplierOptions,
    itemsWithWinner,
    totalItems,
    itemsWithoutWinner,
    hasItensRestantesSemGanhador,
    winnerDistribution,
    totalCost,
    winningSuppliers,
    mainSupplier,
    hasProposals,
    items,
    prazoEntregaReferenciaDias,
    currentIndex,
    currentItem,
    suppliersView,
    filteredSuppliersView,
    hasPartialWinner,
    activeFilters,
    minCoverage,
    hideOutOfTolerance,
    hideAboveReference,
    isAdvancedOptionsExpanded,
    isButtonsDisabled,
    formatCurrency,
    formatQuantity,
    formatLastPurchasePrice,
    isProposalNaoAtende,
    getBadgeConfig,
    getSeloTooltip,
    selosDistribuidosItemView,
    getSeloQuantidadeOfertadaContexto,
    getSeloQuantidadeOfertadaContextoFornecedor,
    deveExibirStatusPropostaFornecedor,
    clearWinners,
    clearFilters,
    removeFilter,
    previousItem,
    nextItem,
    setWinner,
    setWinnerBySupplier,
    confirmSuppliers,
    executeConfirmSuppliers,
    modalConfirmacao,
    saveInAnalysis,
    filteredItems,
    modalItensGanhadores,
    modalFornecedor,
    modalSoloSemGanhador,
    modalItensRows,
    modalItensTotalGeral,
    openModalItensGanhadores,
    closeModalItensGanhadores,
    modalItensFornecedor,
    modalItensFornecedorNome,
    modalItensFornecedorTipo,
    modalItensFornecedorRows,
    modalItensFornecedorTotalGeral,
    openModalItensFornecedor,
    closeModalItensFornecedor,
    baixarXlsxModalItensFornecedor,
    // Ajuste de proposta
    modalAjusteAberto,
    modalAjusteFornecedorSelecionado,
    modalAjustePrazoDias,
    modalAjusteLoading,
    modalAjusteContatos,
    modalAjusteContatosLoading,
    modalAjusteErros,
    modalAjustePrazoFinal,
    modalAjustePrazoExcedido,
    modalAjusteMaxDias,
    terminoCotacaoFormatado,
    ajustesAtivos,
    modalAjusteFornecedorExibicao,
    abrirModalAjuste,
    fecharModalAjuste,
    enviarSolicitacaoAjuste,
    getAjusteAtivoFornecedor,
    formatarDataBR,
  } = useDetalhesCotacaoPropostaTab(props, { emit });
</script>

<style scoped>
.proposal-inline-selos :deep(.status-badge) {
  font-size: 0.7rem;
  line-height: 1.2;
}

.proposta-wrapper {
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 100%;
  min-height: 0;
}

.empty-state-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px;
}

.proposta-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
}

.proposta-head--bar {
  border: none;
  box-shadow: none;
  background: transparent;
  padding: 4px 0 10px 0;
  margin-bottom: 6px;
}

.head-subtitle {
  font-size: 0.8125rem;
  color: #90a4ae;
  line-height: 1.3;
  margin: 0;
}

.head-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: 360px;
}

.head-view {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.head-only-winner {
  margin-top: 0;
}

.summary-only-winner {
  margin-top: -2px;
}

.summary-only-winner :deep(.v-input__slot) {
  margin-bottom: 0 !important;
}

.head-actions {
  display: flex;
  align-items: center;
}

.summary-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.summary-right-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.summary-right-cost {
  padding-top: 6px;
  border-top: 1px solid #eef2f6;
}

.proposta-layout {
  display: flex;
  flex: 1;
  padding-bottom: 15px;
  gap: 16px;
  align-items: flex-start;
  min-height: 0;
}

.sidebar-filter {
  width: 320px;
  background: white;
  padding: 12px;
  flex-shrink: 0;
  align-self: stretch;
  height: 100%;
  overflow: auto;
  border-right: 1px solid #eef2f6;
}

.head-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #071a2a;
}

.head-description {
  color: #5f7080;
  font-size: 0.9rem;
}

.info-banner {
  background: #e9f1ff;
  color: #4766c9;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 0.875rem;
  line-height: 1.4;
  margin-bottom: 16px;
  font-weight: 400;
}

.segmented-control :deep(.v-btn--active) {
  background: #1567b8 !important;
  color: white !important;
}

.view-type-card {
  padding: 16px;
}

.section-card {
  border: 1px solid #e5e9f2;
  border-radius: 6px;
  padding: 16px;
  background: #fff;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;
}

.section-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.section-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
}

.section-card__header:hover {
  opacity: 0.8;
}

.section-card__header .v-icon {
  transition: transform 0.3s ease;
}

.card-content {
  display: block;
}

.sidebar-section {
  margin-bottom: 12px;
}

/* Sidebar deve parecer "coluna inteira" */
.sidebar-filter .sidebar-section:last-child {
  margin-bottom: 0;
}

.sidebar-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #424242;
  margin: 0;
  line-height: 1.4;
}

.sidebar-helper {
  font-size: 0.8125rem;
  color: #757575;
  margin: 0;
  line-height: 1.4;
  font-weight: 400;
}

.field-label {
  display: block;
  font-size: 0.8125rem;
  color: #616161;
  margin-bottom: 6px;
  font-weight: 400;
}

.content {
  flex: 1;
  padding: 8px 0;
  background: #fff;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}

.summary-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  border: 1px solid #e5e9f2;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;
}

.summary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;
}

.ver-detalhes-btn {
  flex-shrink: 0;
  font-size: 0.8125rem !important;
  font-weight: 500;
  letter-spacing: normal;
}

.modal-itens-table thead th {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #64748b !important;
  font-weight: 700 !important;
  background: #f8fafc !important;
}

.modal-itens-table tbody td {
  font-size: 0.875rem;
  vertical-align: middle !important;
}

.summary-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  color: #90a4ae;
  margin-bottom: 4px;
}

.summary-value-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}

.summary-value {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
}

.summary-value-hero {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: nowrap;
}

.summary-value-current {
  font-size: 1.75rem;
  font-weight: 400;
  line-height: 1;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.summary-value-muted {
  font-size: 0.9375rem;
  font-weight: 400;
  color: #94a3b8;
  margin-left: 2px;
}

.summary-helper {
  font-size: 0.8rem;
  color: #90a4ae;
}

.summary-warning {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.progress-bar-wrapper {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.progress-bar {
  display: flex;
  width: 100%;
  height: 12px;
  background-color: #e0e0e0;
  border-radius: 999px;
  overflow: hidden;
}

.progress-segment {
  height: 100%;
  transition: width 0.3s ease;
}

.progress-segment--no-winner {
  background-color: #d1d5db;
}

.supplier-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 2px;
}

.supplier-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #d7dce3;
  border-radius: 999px;
  font-size: 0.75rem;
  color: #6b7280;
  background: #fff;
}

.supplier-chip__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.supplier-matrix {
  width: 100%;
  min-width: 0;
}

/* Scroll horizontal: colunas de fornecedor têm largura mínima fixa para o grid ultrapassar a viewport */
.supplier-matrix__scroll {
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 8px;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
}

.supplier-matrix__grid {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(10, auto);
  align-items: stretch;
  /* Coluna fixa de métricas (rótulos) — não encolhe com muitos fornecedores */
  grid-template-columns: minmax(200px, 240px);
  /* Sem 1fr: 1fr reparte o espaço e impede overflow horizontal com vários fornecedores */
  grid-auto-columns: minmax(260px, 300px);
  gap: 0;
  width: max-content;
  min-width: 100%;
  border: 1px solid #e5e9f2;
  border-radius: 8px;
  background: #fff;
  overflow: visible;
}

.supplier-matrix__metric-col {
  display: contents;
}

.supplier-matrix__metric-head {
  min-height: 104px;
  height: 100%;
  align-self: stretch;
  /* Mesmo padding vertical dos cabeçalhos de fornecedor — texto alinhado ao topo, não ao centro da linha */
  padding: 16px 14px;
  font-size: 0.8125rem;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  color: #94a3b8;
  background: #f8fafc;
  border-bottom: 1px solid #eef2f6;
  border-right: 1px solid #eef2f6;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: sticky;
  left: 0;
  z-index: 3;
  box-shadow: 6px 0 12px -8px rgba(15, 23, 42, 0.18);
  box-sizing: border-box;
}

.supplier-matrix__metric-row {
  padding: 16px 14px;
  font-size: 0.8125rem;
  color: #64748b;
  border-bottom: 1px solid #eef2f6;
  border-right: 1px solid #eef2f6;
  min-height: 48px;
  display: flex;
  align-items: center;
  background: #f8fafc;
  position: sticky;
  left: 0;
  z-index: 2;
  box-shadow: 6px 0 12px -8px rgba(15, 23, 42, 0.12);
}

.supplier-matrix__supplier-col {
  display: contents;
}

.supplier-matrix__supplier-head {
  padding: 16px 14px;
  background: #fff;
  border-bottom: 1px solid #eef2f6;
  border-right: 1px solid #eef2f6;
  min-height: 104px;
  height: 100%;
  align-self: stretch;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 0;
}

.supplier-matrix__supplier-title {
  margin-bottom: 0;
  min-width: 0;
  flex-shrink: 0;
}

.supplier-matrix__supplier-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  cursor: default;
}

.supplier-matrix__supplier-cnpj {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 2px;
}

/* Botões / selos na base do cabeçalho: mesma altura em todas as colunas mesmo com nome em 2 linhas */
.supplier-matrix__supplier-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  margin-top: auto;
  padding-top: 10px;
}

.supplier-matrix__cell {
  padding: 16px 14px;
  font-size: 0.875rem;
  color: #111827;
  border-bottom: 1px solid #eef2f6;
  border-right: 1px solid #eef2f6;
  min-height: 48px;
  display: flex;
  align-items: center;
}

.supplier-matrix__supplier-col:last-child .supplier-matrix__supplier-head,
.supplier-matrix__supplier-col:last-child .supplier-matrix__cell {
  border-right: none;
}

.supplier-matrix__cell-strong {
  color: #16a34a;
  font-weight: 600;
}

.clear-winners-btn {
  font-size: 0.75rem;
  padding: 0 4px;
  min-width: auto;
  height: auto;
}

.clear-filters-btn {
  font-size: 0.75rem;
  padding: 16px 12px !important;
  min-width: auto;
  height: auto;
}

.filter-chip {
  background: #FAFAFA !important;
  border: 1px solid #F3F8FF !important;
  border-radius: 4px !important;
  color: #1976d2 !important;
  padding: 6px 12px !important;
  min-height: auto !important;
  height: auto !important;
}

.items-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #e5e9f2;
}

.items-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 16px;
  background: #fff;
}

.items-card__title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
  line-height: 1.4;
}

.items-card__subtitle {
  font-size: 0.875rem;
  color: #607d8b;
  line-height: 1.5;
  margin: 0;
}

.items-navigation {
  display: flex;
  align-items: center;
  gap: 12px;
}

.items-navigation__text {
  font-size: 0.875rem;
  color: #607d8b;
  font-weight: 400;
}

.nav-buttons {
  display: flex;
  gap: 4px;
}

.nav-btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  border: 1px solid #e0e0e0 !important;
  background: #fff !important;
  color: #424242 !important;
}

.nav-btn:hover {
  background: #f5f5f5 !important;
}

.nav-btn:disabled {
  opacity: 0.4;
}

.product-info {
  padding: 20px 24px 20px 24px;
  border-bottom: 1px solid #eceff1;
  background: #fff;
}

.product-details-table {
  border: 1px solid #E2E2E4;
  border-radius: 6px;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  background: #fff;
  overflow: hidden;
  padding: 16px 16px 16px 14px;
  margin-left: 0;
}

.product-details-table :deep(table) {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.product-details-table :deep(thead) {
  border: none;
}

.product-details-table :deep(tbody) {
  border: none;
}

.product-details-table :deep(thead tr) {
  border: none;
}

.product-details-table :deep(tbody tr) {
  border: none;
}

.product-details-table th {
  font-size: 12px;
  font-weight: 700;
  font-style: normal;
  line-height: 150%;
  color: #000000 !important;
  padding: 12px 16px 4px;
  text-align: left;
  border: none !important;
  background: transparent;
  text-transform: none;
  letter-spacing: normal;
}

.product-details-table th:not(:last-child) {
  border-right: none;
}

.product-details-table td {
  font-size: 0.875rem;
  color: #78909c;
  padding: 0 16px 12px;
  text-align: left;
  border: none !important;
  vertical-align: top;
  font-weight: 400;
}

.product-details-table td:not(:last-child) {
  border-right: none;
}

.product-details-table tbody tr {
  border: none;
}

.proposals-table-wrapper {
  border: 1px solid #E2E2E4;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  padding: 16px 16px 16px 14px;
}

.proposals-table {
  padding: 0;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.proposals-table th {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #000000;
  font-weight: 700;
  letter-spacing: normal;
  border-bottom: 2px dashed #e3f2fd;
  padding: 12px 16px !important;
  background: #fff;
}

.proposals-table td {
  font-size: 0.875rem;
  color: #000000;
  padding: 16px !important;
  border-bottom: 1px dashed #e3f2fd;
  vertical-align: middle !important;
}

.proposals-table tbody tr:last-child td {
  border-bottom: none;
}

.proposal-value {
  color: #000000 !important;
  font-weight: 400;
}

.supplier-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.supplier-name {
  font-weight: 400;
  font-size: 0.875rem;
  color: #000000;
  line-height: 1.4;
}

.supplier-cnpj {
  font-size: 0.75rem;
  color: #000000;
  line-height: 1.4;
  font-weight: 400;
}

.winner-row {
  background: #f0f7ff !important;
}

.winner-row td {
  border-bottom-color: #e3f2fd;
  background: #f0f7ff !important;
}

.no-proposals-text {
  margin-top: 16px;
  font-size: 1.1rem;
  color: #6e6e6e;
  font-weight: 400;
}

/* Estilos para campos de input na sidebar */
.sidebar :deep(.v-input--is-focused .v-input__slot) {
  border-color: #1976d2 !important;
}

.sidebar :deep(.v-text-field--outlined .v-input__control) {
  min-height: 40px;
}

.sidebar :deep(.v-select--outlined .v-input__control) {
  min-height: 40px;
}

.sidebar :deep(.v-input__slot) {
  border-radius: 4px;
  border: none;
}

.sidebar :deep(.v-input--dense .v-input__control) {
  min-height: 40px;
}

/* Estilos para chips de confiabilidade */
.sidebar :deep(.v-chip) {
  height: 28px;
  font-size: 0.8125rem;
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sidebar :deep(.v-chip--small) {
  height: 28px;
  padding: 0 12px;
}

/* Estilos para checkboxes */
.sidebar :deep(.v-input--checkbox .v-input--selection-controls__input) {
  margin-right: 8px;
}

.sidebar :deep(.v-input--checkbox .v-label) {
  font-size: 0.875rem;
  color: #424242;
  font-weight: 400;
  line-height: 1.4;
}

.view-type-checkbox :deep(.v-input__slot) {
  background-color: #FAFAFA !important;
  border: none !important;
  border-radius: 4px !important;
}

.view-type-checkbox {
  margin-top: 4px;
}

.view-type-checkbox :deep(.v-input__slot:focus),
.view-type-checkbox :deep(.v-input__slot:focus-within),
.view-type-checkbox :deep(.v-input--is-focused .v-input__slot) {
  border: none !important;
  box-shadow: none !important;
}

.view-type-checkbox :deep(.v-input--selection-controls__input) {
  margin-right: 8px;
  width: 18px !important;
  height: 30px !important;
  min-width: 18px !important;
  min-height: 18px !important;
}

.view-type-checkbox :deep(.v-input--selection-controls__input .v-icon) {
  color: #245AE5 !important;
  font-size: 20px !important;
}

.view-type-checkbox :deep(.v-label) {
  font-size: 0.875rem;
  color: #424242;
  font-weight: 400;
  transition: color 0.2s ease;
}

.view-type-checkbox :deep(.v-input--is-checked .v-label) {
  color: #245AE5 !important;
}

.view-type-checkbox :deep(.v-input--is-checked .v-input__slot) {
  background-color: #FAFAFA !important;
  border: none !important;
}

.view-type-checkbox :deep(.v-input--is-checked .v-input__slot:focus),
.view-type-checkbox :deep(.v-input--is-checked .v-input__slot:focus-within),
.view-type-checkbox :deep(.v-input--is-checked.v-input--is-focused .v-input__slot) {
  border: none !important;
  box-shadow: none !important;
}

.view-type-checkbox :deep(.v-input--selection-controls__ripple) {
  display: none !important;
}

/* Estilos para radio buttons */
.sidebar :deep(.v-radio .v-label) {
  font-size: 0.875rem;
  color: #424242;
  font-weight: 400;
}

.sidebar :deep(.v-radio--is-selected .v-label) {
  color: #1976d2;
}

.text-error {
  color: #ff5252 !important;
}

.sidebar :deep(.radio-error .v-label) {
  color: #ff5252 !important;
}

.sidebar :deep(.radio-error .v-radio--is-selected .v-label) {
  color: #1976d2 !important;
}

.advanced-options-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 4px 0;
  margin-bottom: 4px;
}

.advanced-options-toggle:hover {
  opacity: 0.7;
}

.prazo-referencia-badge {
  display: inline-flex;
  align-items: center;
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.8125rem;
  color: #1565c0;
  line-height: 1.4;
}

.confirmacao-resumo {
  background: #f8fafc;
  border: 1px solid #e5e9f2;
  border-radius: 8px;
  padding: 16px;
}

.confirmacao-resumo__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.confirmacao-resumo__label {
  font-size: 0.875rem;
  color: #64748b;
}

.confirmacao-resumo__value {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.ajuste-badge-solicitado {
  display: inline-block;
  background: #FFF7ED;
  border: 1px solid #FDBA74;
  color: #C2410C;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
  cursor: help;
}
</style>
